/**
 * Created by Claude on 07.02.2026
 */

const GeneratorMultiplierWindow = CleverappsWindow.extend({
    onWindowLoaded: function (generatorMultiplier) {
        this.generatorMultiplier = generatorMultiplier;
        this.multiplierBeforeChanges = this.generatorMultiplier.getValue();

        this._super({
            name: "GeneratorMultiplierWindow",
            title: Messages.get("GeneratorMultiplierWindow.title"),
            content: this.createContent(),
            closeButton: true
        });
    },

    createContent: function () {
        const styles = cleverapps.styles.GeneratorMultiplierWindow;

        const image = this.createImage();
        const description = this.createDescription();
        const button = this.button = this.createButton();

        return new cleverapps.Layout([image, description, button], {
            direction: cleverapps.UI.VERTICAL,
            margin: styles.margin,
            padding: styles.padding
        });
    },

    createImage: function () {
        return new cc.Sprite(bundles.generator_multiplier_window.frames.generator_multiplier_image_png);
    },

    createDescription: function () {
        const styles = cleverapps.styles.GeneratorMultiplierWindow.description;
        if (!this.description) {
            this.description = new cc.Node();
            this.description.setContentSize2(styles.width, styles.height);
            this.description.setAnchorPoint(0.5, 0.5);
        } else {
            this.description.removeAllChildren();
        }

        const value = this.generatorMultiplier.getValue();
        const items = [];
        if (value === 1) {
            // eslint-disable-next-line no-restricted-syntax
            items.push(cleverapps.UI.generateTTFText(
                Messages.get("GeneratorMultiplierWindow.description.off0"),
                cleverapps.styles.FONTS.GENERATOR_MULTIPLIER_TEXT_1
            ));
            items.push(new TextWithIcon(Messages.get(
                "GeneratorMultiplierWindow.description.off1"
            ), { font: cleverapps.styles.FONTS.GENERATOR_MULTIPLIER_TEXT_1 }));

            // eslint-disable-next-line no-restricted-syntax
            items.push(cleverapps.UI.generateTTFText(
                Messages.get("GeneratorMultiplierWindow.description.off2"),
                cleverapps.styles.FONTS.GENERATOR_MULTIPLIER_TEXT_2
            ));
        } else {
            items.push(new TextWithIcon(Messages.get(
                "GeneratorMultiplierWindow.description1",
                { value }
            ), { font: cleverapps.styles.FONTS.GENERATOR_MULTIPLIER_TEXT_1 }));

            // eslint-disable-next-line no-restricted-syntax
            items.push(cleverapps.UI.generateTTFText(
                Messages.get("GeneratorMultiplierWindow.description2", {
                    level: this.generatorMultiplier.getAdditionalStage()
                }),
                cleverapps.styles.FONTS.GENERATOR_MULTIPLIER_TEXT_2
            ));
        }

        const textLayout = new cleverapps.Layout(items, {
            direction: cleverapps.UI.VERTICAL,
            margin: cleverapps.styles.GeneratorMultiplierWindow.description.margin
        });

        cleverapps.UI.fitToBox(textLayout, styles);
        textLayout.setAlignment({ align: "center" }, { align: "center" });

        this.description.addChild(textLayout);
        return this.description;
    },

    createButton: function () {
        const styles = cleverapps.styles.GeneratorMultiplierWindow.button;
        const value = this.generatorMultiplier.getValue();

        const button = this.button = new cleverapps.UI.Button({
            type: GeneratorMultiplierWindow.getButtonType(value),
            text: `%% x${value}`,
            width: styles.width,
            height: styles.height,
            onClicked: this.onButtonClicked.bind(this)
        });

        button.content.x += styles.textOffsetX;

        const arrows = this.arrows = new cc.Sprite(bundles.generator_multiplier_window.frames[`arrows_${value}_png`]);
        button.addChild(arrows);
        arrows.setAlignment(styles.arrows);

        const shadow = cleverapps.UI.createScale9Sprite(bundles.generator_multiplier_window.frames.button_shadow_png, { x: 0.1, y: 0.5 });
        shadow.setContentSize(styles.shadow.width, styles.shadow.height);
        button.addChild(shadow);
        shadow.setAlignment(styles.shadow);

        return button;
    },

    onButtonClicked: function () {
        this.generatorMultiplier.increment();
        cleverapps.tutorial.trigger("generator_multiplier_button_clicked");
        const value = this.generatorMultiplier.getValue();

        this.button.setString(`%% x${value}`);

        const type = GeneratorMultiplierWindow.getButtonType(value);
        this.button.settings.type = type;
        this.button.background.setSpriteFrame(type.button_png);

        this.arrows.setSpriteFrame(bundles.generator_multiplier_window.frames[`arrows_${value}_png`]);

        this.createDescription();
    },

    onClose: function () {
        if (this.multiplierBeforeChanges !== this.generatorMultiplier.getValue()) {
            this.generatorMultiplier.wantToShowChanged = true;
        }
    },

    listBundles: function () {
        return ["generator_multiplier_window"];
    }
});

GeneratorMultiplierWindow.getButtonType = function (value) {
    return {
        button_png: bundles.generator_multiplier_window.frames[`button_${value}`],
        button_on_png: bundles.generator_multiplier_window.frames[`button_${value}_on`]
    };
};

cleverapps.overrideStyles(cleverapps.styles.FONTS, {
    GENERATOR_MULTIPLIER_TEXT_1: {
        name: "default",
        color: cleverapps.styles.COLORS.COLOR_WINDOW_TEXT,
        size: 40
    },
    GENERATOR_MULTIPLIER_TEXT_2: {
        name: "default",
        color: new cc.Color(44, 149, 231, 255),
        size: 40
    }
});

cleverapps.styles.GeneratorMultiplierWindow = {
    margin: 50,
    padding: {
        top: 10,
        bottom: 40
    },

    description: {
        width: 680,
        height: 150,
        margin: 5
    },

    button: {
        width: 450,
        height: 110,
        textOffsetX: -20,

        arrows: {
            x: { align: "right", dx: -40 },
            y: { align: "center" }
        },

        shadow: {
            width: 110,
            height: 110,
            x: { align: "right" },
            y: { align: "center" }
        }
    }
};